import React from 'react';
import { cn } from '@/lib/utils';

// Import official SVG logos from pos-dashboard assets
import GrabLogoSvg from '../assets/logos/grab_logo.svg';
import ShopeeLogoSvg from '../assets/logos/shopee_logo.svg';
import XanhSMLogoSvg from '../assets/logos/xanhsm_logo.svg';

export const GrabLogo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <img
      src={GrabLogoSvg}
      alt="Grab"
      className={cn('w-8 h-8 object-contain', className)}
    />
  );
};

export const ShopeeLogo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <img
      src={ShopeeLogoSvg}
      alt="Shopee"
      className={cn('w-8 h-8 object-contain', className)}
    />
  );
};

export const XanhSMLogo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <img
      src={XanhSMLogoSvg}
      alt="Xanh SM"
      className={cn('w-8 h-8 object-contain', className)}
    />
  );
};
